
import {updateImages, updateURLs} from '../product/productUtils';
import {setupVariationListeners} from '../product/variationsUtils';
import {setupAddToCart} from '../product/addToCart';
import {callbackOnElements} from '@borngroup/born-utilities';



export default class ProductTile {
    constructor(options) {
        callbackOnElements(options.elements, this.setupTile.bind(this));
    }

    setupTile(currentTile) {
        this.setPermanentImageData(currentTile);

        this.setupSwatches(currentTile);

        this.setupSecondaryImageDisplay(currentTile);
        setupVariationListeners(currentTile);
        setupAddToCart(currentTile);
    }

    setupSwatches(currentTile) {
        let swatches = currentTile.querySelectorAll('[data-product-swatch]'),
            swatchesContainer = currentTile.querySelector('[data-product-component="swatches"]');

        [].forEach.call(swatches, currentSwatch => this.setupSingleSwatch(currentSwatch, currentTile));

        if (swatchesContainer) {
            swatchesContainer.addEventListener('mouseleave', function() {
                updateImages(currentTile.permanentImageData, currentTile);
            });
        }
    }

    setupSingleSwatch(currentSwatch, currentTile) {
        let swatchData = JSON.parse(currentSwatch.getAttribute('data-product-swatch'));

        currentSwatch.addEventListener('click', this.swatchSelectHandler.bind(this, swatchData, currentSwatch, currentTile));
        currentSwatch.addEventListener('mouseenter', updateImages.bind(this, swatchData.images, currentTile, undefined));
    }

    swatchSelectHandler(swatchData, currentSwatch, currentTile, evt) {
        evt.preventDefault();

        updateImages(swatchData.images, currentTile);

        updateURLs(currentSwatch.getAttribute('data-query-string'), currentTile);

        this.unselectAllSwatches(currentTile);
        this.setSelected(currentSwatch, currentTile);

        currentTile.permanentImageData = swatchData.images;
    }

    unselectAllSwatches(currentTile) {
        let currentSelectedSwatches = currentTile.querySelectorAll('[data-product-swatch].selected');

        [].forEach.call(currentSelectedSwatches, currentSwatch => currentSwatch.classList.remove('selected'));
    }

    setSelected(currentSwatch) {
        currentSwatch.classList.add('selected');
    }

    setPermanentImageData(currentTile) {
        let productImages = currentTile.querySelectorAll('[data-product-component="image"]');

        currentTile.permanentImageData = [];

        [].forEach.call(productImages, function(currentImage) {
            currentTile.permanentImageData[currentImage.getAttribute('data-image-index')] = {
                url: currentImage.src || currentImage.getAttribute('data-src'),
                title: currentImage.title,
                alt: currentImage.alt
            };
        }.bind(this));
    }

    //This utility adds a special class "set--images-lazy-loaded" to the product tiles.
    //This class is the used in the CSS to ensure that the "main" product image is not hidden when hovering on a tile.
    //This is necessary because the product images are transparent, and on hover the secondary image must show.
    //The secondary image however needs to be fully loaded before letting the tile show it, hence the need for this snippet.
    setupSecondaryImageDisplay(currentTile) {
        currentTile.addEventListener('lazyloaded', function(evt) {
            if (evt.target.dataset.imageIndex > 0) {
                currentTile.classList.add('set--images-lazy-loaded');
            }
        });
    }
}
